<div @fadeT class="content-tips">
  <div class="container-text">
  </div>
  <div class="left" *ngIf="!show && mainTip">
    <div class="container">
      <div class="text-container">
        <div class="tip">
          <p class="tittle">{{item.name}}</p>
          <img class="icon" src="./assets/global-position/tips/{{item.IdCategory}}.png" alt="">
          <div class="information">
            <div class="all-information">
              <p class="category">{{ item.Category }}</p>
              <p class="message">{{ item.Message }}</p>
            </div>
          </div>
        </div>
      </div>
      <img class="rocket" src="./assets/global-position/tips/cohete.svg" alt="">
    </div>
    <hr>
  </div>
  <div class="" *ngIf="!show">
    <div class="tips" [hidden]="show">
      <ul id="autoWidth" class="cs-hidden">
        <li class="item-a" *ngFor="let i of list">
          <div class="tip" (click)="selectedItem(i)">
            <p class="tittle">{{i.name}}</p>
            <img class="icon" src="./assets/global-position/tips/{{i.IdCategory}}.png" alt="">
            <div class="information">
              <div class="all-information">
                <p class="category">{{ i.Category }}</p>
                <p class="message" style="display: block;">{{ getSubString(i.Message) }}... <span
                    style="color: #08696e; font-size: 13px;">ver
                    mas</span>
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>

    </div>

  </div>
  <div class="simply-banner-container">
    <div class="simply-banner">
      <div class="icon-container">
        <img src="./assets/tips/hat-icon.svg" alt="">
      </div>
      <div class="text">
        Descubre <strong>Simple Finance</strong> y aprende a mantener tus finanzas bajo control
      </div>
      <div class="button-container">
        <a href="https://simplefinance.santanderconsumer.es/" target="_blank">
          Ir a Simple Finance
        </a>
      </div>
    </div>
  </div>
  <div class="right" *ngIf="show">
    <div class="ok">
      <img src="./assets/global-position/tips/hand_ok.svg" alt="">
      <br>
      <p class="continue">Sigue así, lo estás <br> haciendo genial</p>
      <p class="health">
        Tu Salud Financiera es excelente. <br> <br>
        Continúa controlando tus cuentas y gestionando <br>
        tus gastos para no perder el buen ritmo.
      </p>
    </div>
  </div>
  <div class="height-menu" style="height: 78px;"></div>
</div>
<app-loading-akana *ngIf="showLoading"></app-loading-akana>